import { render, staticRenderFns } from "./DiscardSignatureModal.vue?vue&type=template&id=446971d9"
import script from "./DiscardSignatureModal.vue?vue&type=script&lang=js"
export * from "./DiscardSignatureModal.vue?vue&type=script&lang=js"
import style0 from "./DiscardSignatureModal.vue?vue&type=style&index=0&id=446971d9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports